import FULL_CONFIG_FLOW from './testsConfig/fullConfigFlow'
import FULL_CONFIG_FLOW_V2 from './testsConfig/fullConfigFlowV2'
import FULL_CONFIG_FLOW_FAST_TRACK from './testsConfig/fullConfigFlowFastTrack'
import MINIMUM_CONFIG_FLOW from './testsConfig/minimumConfigFlow'
import MINIMUM_CONFIG_FLOW_V2 from './testsConfig/minimumConfigFlowV2'

const TESTS = {
  FULL_CONFIG_FLOW,
  MINIMUM_CONFIG_FLOW,
  FULL_CONFIG_FLOW_V2,
  MINIMUM_CONFIG_FLOW_V2,
  FULL_CONFIG_FLOW_FAST_TRACK,
}

export default TESTS
